export { default } from "ember-stereo/helpers/play-sound";
